/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInvite,
    JsonInviteFromJSON,
    JsonInviteFromJSONTyped,
    JsonInviteToJSON,
} from './JsonInvite';

/**
 * 
 * @export
 * @interface ApiResultOfJsonInvite
 */
export interface ApiResultOfJsonInvite {
    /**
     * 
     * @type {JsonInvite}
     * @memberof ApiResultOfJsonInvite
     */
    data?: JsonInvite;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInvite
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonInvite
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInvite
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInvite
     */
    result?: ApiResultOfJsonInviteResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonInviteResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonInviteFromJSON(json: any): ApiResultOfJsonInvite {
    return ApiResultOfJsonInviteFromJSONTyped(json, false);
}

export function ApiResultOfJsonInviteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonInvite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonInviteFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonInviteToJSON(value?: ApiResultOfJsonInvite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonInviteToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

